import { useState } from 'react';

// Photo URLs come only from the roster response. Never fetch a second profile.
export default function RosterAvatar({ src, firstName = '', lastName = '' }) {
  const [failedSrc, setFailedSrc] = useState(null);
  const initials = `${(firstName || "").trim().charAt(0)}${(lastName || "").trim().charAt(0)}`.toUpperCase() || '?';
  const showImage = Boolean(src && src !== failedSrc);
  return <span className="roster-avatar" aria-hidden="true" data-initials={showImage ? undefined : initials}>
    {showImage && <img src={src} alt="" loading="lazy" draggable={false} onError={() => setFailedSrc(src)} />}
  </span>;
}
